(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bhrt"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('.area-block');
    const buttons = document.querySelectorAll('.area-btn');

    function showBlock(index) {
      blocks.forEach((block, i) => {
        block.classList.toggle('active', i == index);
      });

      buttons.forEach((btn, i) => {
        btn.classList.toggle('active', i == index);
      });
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', function () {
        const index = this.dataset.index;
        showBlock(index);
      });
    });

    // Default state
    showBlock(0);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const options = document.querySelectorAll('.option');

    options.forEach((option) => {
      const header = option.querySelector('.option-header');
      const body = option.querySelector('.option-body');
      const toggle = option.querySelector('.toggle');

      option.addEventListener('click', function () {
        const isOpen = option.classList.contains('active');

        // Close all
        options.forEach((item) => {
          item.classList.remove('active');
          const itemBody = item.querySelector('.option-body');
          const itemToggle = item.querySelector('.toggle');

          itemBody.style.height = '0px';
          itemToggle.textContent = '+';
        });

        // If it was closed, open it
        if (!isOpen) {
          option.classList.add('active');

          body.style.height = body.scrollHeight + 'px';
          toggle.textContent = '−';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experts"] && !Shopify.designMode) return;
  try {
    
  const experts = document.querySelectorAll('.expert');

  experts.forEach((item) => {
    const header = item.querySelector('.expert-header');
    const body = item.querySelector('.expert-body');

    header.addEventListener('click', () => {
      if (item.classList.contains('active')) {
        item.classList.remove('active');
        body.style.maxHeight = null;
        return;
      }

      experts.forEach((e) => {
        e.classList.remove('active');
        e.querySelector('.expert-body').style.maxHeight = null;
      });

      item.classList.add('active');
      body.style.maxHeight = body.scrollHeight + 'px';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-doctors"] && !Shopify.designMode) return;
  try {
    
  function initSlider(sectionSelector) {
    const section = document.querySelector(sectionSelector);
    const track = section.querySelector('.track');
    const cards = section.querySelectorAll('.card');
    const btnNext = section.querySelector('.right');
    const btnPrev = section.querySelector('.left');

    let currentIndex = 0;
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID;

    const gap = 25;

    const getCardWidth = () => cards[0].offsetWidth + gap;
  const getMaxTranslate = () => {
  const trackWidth = section.querySelector('.track').parentElement.offsetWidth;
  const totalWidth = getCardWidth() * cards.length - gap;
  return Math.min(0, -(totalWidth - trackWidth));
};

    const setPosition = () => {
      track.style.transform = `translateX(${currentTranslate}px)`;
    };

    const animation = () => {
      setPosition();
      if (isDragging) requestAnimationFrame(animation);
    };

  const snapToCard = () => {
  const cardWidth = getCardWidth();
  const maxTranslate = getMaxTranslate();

  currentIndex = Math.round(Math.abs(currentTranslate) / cardWidth);

  if (currentIndex < 0) currentIndex = 0;
  if (currentIndex > cards.length - 1) currentIndex = cards.length - 1;

  currentTranslate = Math.max(-currentIndex * cardWidth, maxTranslate);
  prevTranslate = currentTranslate;

  track.style.transition = 'transform 0.4s ease';
  setPosition();
};

    const getPositionX = (e) => (e.type.includes('mouse') ? e.pageX : e.touches[0].clientX);

    const startDrag = (e) => {
      isDragging = true;
      startX = getPositionX(e);
      track.style.transition = 'none';
      animationID = requestAnimationFrame(animation);
    };

    const drag = (e) => {
      if (!isDragging) return;

      const currentPosition = getPositionX(e);
      currentTranslate = prevTranslate + currentPosition - startX;

      if (currentTranslate > 0) currentTranslate = 0;
      if (currentTranslate < getMaxTranslate()) currentTranslate = getMaxTranslate();
    };

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      cancelAnimationFrame(animationID);
      snapToCard();
    };

    const moveToIndex = () => {
      const cardWidth = getCardWidth();
      currentTranslate = -currentIndex * cardWidth;
      prevTranslate = currentTranslate;
      track.style.transition = 'transform 0.4s ease';
      setPosition();
    };
btnNext.addEventListener('click', () => {
  const maxTranslate = getMaxTranslate();
  if (currentIndex < cards.length - 1 && -currentIndex * getCardWidth() > maxTranslate) {
    currentIndex++;
    moveToIndex();
  }
});

    btnPrev.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        moveToIndex();
      }
    });

    track.addEventListener('mousedown', startDrag);
    track.addEventListener('touchstart', startDrag);

    track.addEventListener('mousemove', drag);
    track.addEventListener('touchmove', drag);

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('touchend', endDrag);
  }
  initSlider('.doctors');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-faq"] && !Shopify.designMode) return;
  try {
    
  function initFAQ(sectionSelector) {
  const section = document.querySelector(sectionSelector);
  const items = section.querySelectorAll(".faq-item");

  items.forEach(item => {
    // const question = item.querySelector(".faq-question");

    item.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      items.forEach(i => i.classList.remove("active"));

      if (!isActive) {
        item.classList.add("active");
      }
    });
  });
}

initFAQ(".faq");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const el = document.querySelector('.typewriter');
    if (!el) return;

    const words = JSON.parse(el.getAttribute('data-words'));
    let wordIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    function typeEffect() {
      const currentWord = words[wordIndex];

      if (!isDeleting) {
        el.textContent = currentWord.substring(0, charIndex + 1);
        charIndex++;

        if (charIndex === currentWord.length) {
          setTimeout(() => (isDeleting = true), 1000);
        }
      } else {
        el.textContent = currentWord.substring(0, charIndex - 1);
        charIndex--;

        if (charIndex === 0) {
          isDeleting = false;
          wordIndex = (wordIndex + 1) % words.length;
        }
      }

      setTimeout(typeEffect, isDeleting ? 50 : 100);
    }

    typeEffect();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-products"] && !Shopify.designMode) return;
  try {
    
  function initSlider(sectionSelector) {
    const section = document.querySelector(sectionSelector);
    const track = section.querySelector('.track');
    const cards = section.querySelectorAll('.card');
    const btnNext = section.querySelector('.right');
    const btnPrev = section.querySelector('.left');

    let currentIndex = 0;
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID;

    const gap = 25;

    const getCardWidth = () => cards[0].offsetWidth + gap;
    const getMaxTranslate = () => {
      const trackVisible = section.querySelector('.wrapper').offsetWidth;
      const totalWidth = getCardWidth() * cards.length - gap;
      return Math.min(0, -(totalWidth - trackVisible));
    };

    const setPosition = () => {
      track.style.transform = `translateX(${currentTranslate}px)`;
    };

    const animation = () => {
      setPosition();
      if (isDragging) requestAnimationFrame(animation);
    };

    const snapToCard = () => {
      const cardWidth = getCardWidth();
      const maxTranslate = getMaxTranslate();

      currentIndex = Math.round(Math.abs(currentTranslate) / cardWidth);

      if (currentIndex < 0) currentIndex = 0;
      if (currentIndex > cards.length - 1) currentIndex = cards.length - 1;

      currentTranslate = Math.max(-currentIndex * cardWidth, maxTranslate);
      prevTranslate = currentTranslate;

      track.style.transition = 'transform 0.4s ease';
      setPosition();
    };

    const getPositionX = (e) => (e.type.includes('mouse') ? e.pageX : e.touches[0].clientX);

    const startDrag = (e) => {
      isDragging = true;
      startX = getPositionX(e);
      track.style.transition = 'none';
      animationID = requestAnimationFrame(animation);
    };

    const drag = (e) => {
      if (!isDragging) return;

      const currentPosition = getPositionX(e);
      currentTranslate = prevTranslate + currentPosition - startX;

      if (currentTranslate > 0) currentTranslate = 0;
      if (currentTranslate < getMaxTranslate()) currentTranslate = getMaxTranslate();
    };

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      cancelAnimationFrame(animationID);
      snapToCard();
    };

    const moveToIndex = () => {
      const cardWidth = getCardWidth();
      currentTranslate = -currentIndex * cardWidth;
      prevTranslate = currentTranslate;
      track.style.transition = 'transform 0.4s ease';
      setPosition();
    };

    btnNext.addEventListener('click', () => {
      const maxTranslate = getMaxTranslate();
      if (currentIndex < cards.length - 1 && currentTranslate > maxTranslate) {
        currentIndex++;
        const cardWidth = getCardWidth();
        currentTranslate = Math.max(-currentIndex * cardWidth, maxTranslate);
        prevTranslate = currentTranslate;
        track.style.transition = 'transform 0.4s ease';
        setPosition();
      }
    });

    btnPrev.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        moveToIndex();
      }
    });

    track.addEventListener('mousedown', startDrag);
    track.addEventListener('touchstart', startDrag);

    track.addEventListener('mousemove', drag);
    track.addEventListener('touchmove', drag);

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('touchend', endDrag);
  }
  initSlider('.products');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-testimonials"] && !Shopify.designMode) return;
  try {
    
  function initTestimonialSlider(sectionSelector) {
    const section = document.querySelector(sectionSelector);
    const track = section.querySelector('.track');
    const slides = section.querySelectorAll('.slide');
    const btnNext = section.querySelector('.right');
    const btnPrev = section.querySelector('.left');

    let currentIndex = 0;
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID;

    const gap = 32; // track gap (2rem approx)

    const getSlideWidth = () => slides[0].offsetWidth + gap;

    const getMaxTranslate = () => -(getSlideWidth() * (slides.length - 1));

    const setPosition = () => {
      track.style.transform = `translateX(${currentTranslate}px)`;
    };

    const animation = () => {
      setPosition();
      if (isDragging) requestAnimationFrame(animation);
    };

    const snapToSlide = () => {
      const slideWidth = getSlideWidth();

      currentIndex = Math.round(Math.abs(currentTranslate) / slideWidth);

      if (currentIndex < 0) currentIndex = 0;
      if (currentIndex > slides.length - 1) currentIndex = slides.length - 1;

      currentTranslate = -currentIndex * slideWidth;
      prevTranslate = currentTranslate;

      track.style.transition = 'transform 0.4s ease';
      setPosition();
    };

    const getPositionX = (e) => (e.type.includes('mouse') ? e.pageX : e.touches[0].clientX);

    const startDrag = (e) => {
      isDragging = true;
      startX = getPositionX(e);
      track.style.transition = 'none';
      animationID = requestAnimationFrame(animation);
    };

    const drag = (e) => {
      if (!isDragging) return;

      const currentPosition = getPositionX(e);
      currentTranslate = prevTranslate + currentPosition - startX;

      if (currentTranslate > 0) currentTranslate = 0;
      if (currentTranslate < getMaxTranslate()) currentTranslate = getMaxTranslate();
    };

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      cancelAnimationFrame(animationID);
      snapToSlide();
    };

    const moveToIndex = () => {
      const slideWidth = getSlideWidth();
      currentTranslate = -currentIndex * slideWidth;
      prevTranslate = currentTranslate;
      track.style.transition = 'transform 0.4s ease';
      setPosition();
    };

    btnNext.addEventListener('click', () => {
      if (currentIndex < slides.length - 1) {
        currentIndex++;
        moveToIndex();
      }
    });

    btnPrev.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        moveToIndex();
      }
    });

    track.addEventListener('mousedown', startDrag);
    track.addEventListener('touchstart', startDrag);

    track.addEventListener('mousemove', drag);
    track.addEventListener('touchmove', drag);

    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('touchend', endDrag);
  }

  initTestimonialSlider('.testimonials');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-together"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.getElementById('together-track');
    if (!track) return;

    var cards = Array.from(track.querySelectorAll('.card'));
    if (!cards.length) return;

    var current = 0;

    // Keep current index in sync with native scroll (for arrows)
    track.addEventListener(
      'scroll',
      function () {
        var cardWidth = cards[0].offsetWidth + 16; // 16 = gap
        current = Math.round(track.scrollLeft / cardWidth);
      },
      { passive: true }
    );

    // Arrows only — no touch handling at all, native scroll-snap does it
    var prevBtn = document.getElementById('together-prev');
    var nextBtn = document.getElementById('together-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        current = Math.max(0, current - 1);
        track.scrollTo({ left: (cards[0].offsetWidth + 16) * current, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        current = Math.min(cards.length - 1, current + 1);
        track.scrollTo({ left: (cards[0].offsetWidth + 16) * current, behavior: 'smooth' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hrt-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-question').forEach(function (button) {
    button.addEventListener('click', function () {
      const item = button.parentElement;
      const answer = item.querySelector('.faq-answer');

      document.querySelectorAll('.faq-item').forEach(function (el) {
        if (el !== item) {
          el.classList.remove('active');
          el.querySelector('.faq-answer').style.height = '0';
        }
      });

      if (item.classList.contains('active')) {
        item.classList.remove('active');
        answer.style.height = '0';
      } else {
        item.classList.add('active');
        answer.style.height = answer.scrollHeight + 'px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hrt"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('.area-block');
    const buttons = document.querySelectorAll('.area-btn');

    function showBlock(index) {
      blocks.forEach((block, i) => {
        block.classList.toggle('active', i == index);
      });

      buttons.forEach((btn, i) => {
        btn.classList.toggle('active', i == index);
      });
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', function () {
        const index = this.dataset.index;
        showBlock(index);
      });
    });

    // Default state
    showBlock(0);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const options = document.querySelectorAll('.option');

    options.forEach((option) => {
      const header = option.querySelector('.option-header');
      const body = option.querySelector('.option-body');
      const toggle = option.querySelector('.toggle');

      option.addEventListener('click', function () {
        const isOpen = option.classList.contains('active');

        // Close all
        options.forEach((item) => {
          item.classList.remove('active');
          const itemBody = item.querySelector('.option-body');
          const itemToggle = item.querySelector('.toggle');

          itemBody.style.height = '0px';
          itemToggle.textContent = '+';
        });

        // If it was closed, open it
        if (!isOpen) {
          option.classList.add('active');

          body.style.height = body.scrollHeight + 'px';
          toggle.textContent = '−';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faqs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq-question').forEach(function (button) {
    button.addEventListener('click', function () {
      const item = button.parentElement;
      const answer = item.querySelector('.faq-answer');

      document.querySelectorAll('.faq-item').forEach(function (el) {
        if (el !== item) {
          el.classList.remove('active');
          el.querySelector('.faq-answer').style.height = '0';
        }
      });

      if (item.classList.contains('active')) {
        item.classList.remove('active');
        answer.style.height = '0';
      } else {
        item.classList.add('active');
        answer.style.height = answer.scrollHeight + 'px';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wwd-areas"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('.area-block');
    const buttons = document.querySelectorAll('.area-btn');

    function showBlock(index) {
      blocks.forEach((block, i) => {
        block.classList.toggle('active', i == index);
      });
      buttons.forEach((btn, i) => {
        btn.classList.toggle('active', i == index);
      });
    }

    buttons.forEach((btn) => {
      btn.addEventListener('click', function () {
        showBlock(this.dataset.index);
      });
    });

    showBlock(0);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const options = document.querySelectorAll('.option');

    options.forEach((option) => {
      const body = option.querySelector('.option-body');
      const toggle = option.querySelector('.toggle');

      option.addEventListener('click', function () {
        const isOpen = option.classList.contains('active');

        options.forEach((item) => {
          item.classList.remove('active');
          item.querySelector('.option-body').style.height = '0px';
          item.querySelector('.toggle').textContent = '+';
        });

        if (!isOpen) {
          option.classList.add('active');
          body.style.height = body.scrollHeight + 'px';
          toggle.textContent = '−';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
